import script from "./AgentEmotion.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentEmotion.vue?vue&type=script&setup=true&lang=js"

import "./AgentEmotion.vue?vue&type=style&index=0&id=42ba47f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ba47f9"]])

export default __exports__